import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-text-lg"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-text-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!

  return (_ctx.isAdmin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SfRouterLink, {
          to: "/sf-admin/view-as",
          class: "tw-no-underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" View as someone else ")
          ]),
          _: 1
        })
      ]))
    : (_ctx.viewingAsSomeoneElse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exitViewAs && _ctx.exitViewAs(...args)), ["prevent"])),
            class: "tw-no-underline"
          }, " View as admin ")
        ]))
      : _createCommentVNode("", true)
}